import * as React from "react"
import type { SVGProps } from "react"
const SvgSection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.99 18h16.03q.43 0 .7.29.28.29.28.71c0 .42-.1.52-.29.71a1 1 0 0 1-.69.29H3.98a1 1 0 0 1-.7-.29A1 1 0 0 1 3 19q0-.42.29-.71a1 1 0 0 1 .68-.29zM5 14h14v-4H5zM4 4h16.03q.43 0 .7.29.28.29.28.71c0 .42-.1.52-.29.71A1 1 0 0 1 20 6H3.98a1 1 0 0 1-.7-.29A1 1 0 0 1 3 5q0-.42.29-.71a1 1 0 0 1 .7-.29m-.4 11.41q.59.6 1.41.59h14q.83 0 1.41-.59.6-.58.59-1.41v-4q0-.82-.59-1.41A2 2 0 0 0 19 8H5q-.82 0-1.41.59A2 2 0 0 0 3 10v4q0 .83.59 1.41"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSection
